"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const COMPASS_AMBER = "#B5680A";

const CompassAnswerReadySection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, sm: 8, md: 6 },
        backgroundColor: "#FFFFFF",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        {/* Top - centered header */}
        <Box sx={{ textAlign: "center", mb: { xs: 5, md: 8 } }}>
          <Typography
            sx={{
              fontSize: { xs: "10px", sm: "11px" },
              fontWeight: 600,
              color: COMPASS_AMBER,
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              fontFamily: "var(--font-outfit)",
              mb: { xs: 1.5, sm: 2 },
            }}
          >
            {t("compassAnswerReady.label")}
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "24px", sm: "30px", md: "36px", lg: "40px" },
              fontWeight: 700,
              lineHeight: 1.25,
              color: "#14122B",
              fontFamily: "var(--font-plusjakarta)",
              maxWidth: 920,
              mx: "auto",
              mb: { xs: 2, sm: 2.5 },
            }}
          >
            {t("compassAnswerReady.heading.main")}{" "}
            <Box component="span" sx={{ color: COMPASS_AMBER }}>
              {t("compassAnswerReady.heading.highlight")}
            </Box>
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "13px", sm: "14px", md: "14.5px" },
              color: "#55556E",
              lineHeight: 1.8,
              fontWeight: 400,
              fontFamily: "var(--font-outfit)",
              maxWidth: 780,
              mx: "auto",
            }}
          >
            {t("compassAnswerReady.description")}
          </Typography>
        </Box>

        {/* Bottom - card */}
        <Box
          sx={{
            maxWidth: '100%',
            mx: "auto",
            backgroundColor: "#F6F2FF",
            border: "1px solid #EDE6FA",
            borderRadius: { xs: "16px", md: "20px" },
            px: { xs: 3, sm: 4, md: 5 },
            py: { xs: 4, md: 5 },
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1.3fr" },
            gap: { xs: 3, md: 6 },
            alignItems: "center",
          }}
        >
          <Box sx={{ textAlign: isArabic ? "right" : "left" }}>
            <Typography
              sx={{
                fontSize: { xs: "9px", sm: "10px" },
                fontWeight: 600,
                color: COMPASS_AMBER,
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                fontFamily: "var(--font-outfit)",
                mb: { xs: 1.5, sm: 2 },
              }}
            >
              {t("compassAnswerReady.card.label")}
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: "22px", sm: "26px", md: "28px" },
                fontWeight: 700,
                lineHeight: 1.2,
                color: "#14122B",
                fontFamily: "var(--font-plusjakarta)",
              }}
            >
              {t("compassAnswerReady.card.heading")}
            </Typography>
          </Box>

          <Typography
            sx={{
              fontSize: { xs: "13px", sm: "13.5px", md: "14px" },
              color: "#2E2B4A",
              lineHeight: 1.8,
              fontWeight: 400,
              fontFamily: "var(--font-outfit)",
              textAlign: isArabic ? "right" : "left",
            }}
          >
            {t("compassAnswerReady.card.description")}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default CompassAnswerReadySection;